
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class BackButton extends Vue {
  @Prop({ type: String, default: 'Back' }) private readonly text!: string;
  @Prop(String) private readonly routePath!: string;
  @Prop({ type: String, default: 'white' }) private readonly color!: string;
}
